export const SET_WALL_COLOR = 'SET_WALL_COLOR';
export const RENDER_OVERLAY = 'RENDER_OVERLAY';
export const SET_PIECE_WIDTH = 'SET_PIECE_WIDTH';
export const SET_PIECE_HEIGHT = 'SET_PIECE_HEIGHT';
export const SET_PIECE_DEPTH = 'SET_PIECE_DEPTH';
export const SET_FRAME = 'SET_FRAME';
export const FETCH_VIEW_SETTINGS_REQUEST = 'FETCH_VIEW_SETTINGS_REQUEST';
export const FETCH_VIEW_SETTINGS_SUCCESS = 'FETCH_VIEW_SETTINGS_SUCCESS';
export const FETCH_VIEW_SETTINGS_FAILURE = 'FETCH_VIEW_SETTINGS_FAILURE';
export const PDF_LOADING='PDF_LOADING';